import {
  CreateAnnouncementDto,
  CreatePrefilledFlixcheckUrlDto,
  IAnnouncement,
  IFlixcheckCheck,
  IMakeComWebhook,
} from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class MakeComApi {
  static async saveWebhook(webhookUrl: string, apiKey: string): Promise<AxiosResponse<string>> {
    return AdmiralApi.apiCall<string>({
      method: 'POST',
      url: `${BASE_URL}/integrations/makecom/save-webhook`,
      data: { webhookUrl, apiKey },
    });
  }

  static async getWebhook(): Promise<AxiosResponse<IMakeComWebhook>> {
    return AdmiralApi.apiCall<IMakeComWebhook>({
      method: 'POST',
      url: `${BASE_URL}/integrations/makecom/get-webhook`,
    });
  }
}
